/**
 * ZUMII Smooth Scroll Engine (Powered by Lenis)
 * Gives Framer-like silky momentum physics with 60/120fps hardware acceleration.
 */

(function () {
  if (typeof window === 'undefined') return;

  // Respect user preference for reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof Lenis === 'undefined') return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 0.95,
      touchMultiplier: 1.5,
      infinite: false,
    });

    window.lenis = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Synchronize with Shopify modals, drawers, and cart
    const observer = new MutationObserver(() => {
      const isModalOpen =
        document.body.classList.contains('overflow-hidden') ||
        document.querySelector('.cart-drawer.active') ||
        document.querySelector('details[open] > .menu-drawer');

      if (isModalOpen) {
        lenis.stop();
      } else {
        lenis.start();
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      subtree: false,
    });

    // Mark Shopify interactive drawers with data-lenis-prevent
    document.querySelectorAll('.cart-drawer, .menu-drawer, .modal__content, .facets__wrapper').forEach((el) => {
      el.setAttribute('data-lenis-prevent', '');
    });
  });
})();
